import { GET_SPORTACCOMPLISHMENT,ADD_SPORTACCOMPLISHMENT,TOST_MESSAGE, UPDATE_SPORTACCOMPLISHMENT, DELETE_SPORTACCOMPLISHMENT } from '../actions/actionTypes';

const initialState = {
  sportaccomplishmentscardItemData:[],sportaccomplishmentstotalCount:0,sportaccomplishmentscardData:[],cardItemDataShow:false,openTost:false,Tost_msg:'',Msg_type:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).issueDate;

  console.log('date1',date1);

  return date1;
}



export default function sportaccomplishments(state = initialState, action) {

  switch (action.type) {
      case GET_SPORTACCOMPLISHMENT:
      
      return{
       ...state,
       sportaccomplishmentscardData: action.getCardData,
       sportaccomplishmentstotalCount:action.totalCount,
       sportaccomplishmentscardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
      case ADD_SPORTACCOMPLISHMENT:
        console.log("Action in add sport accomplishment",action)
        if(!action.newlyAddedSportsAccomplishment) {
          //sports accomplishment addition failed for some reason, just return back previous state
          return {
            ...state
          }
        }


        let updatedSportsAccomplishments = state.sportaccomplishmentscardItemData

        if(!action.uploadedImage) {
          updatedSportsAccomplishments.push(action.newlyAddedSportsAccomplishment)
        } else {
          updatedSportsAccomplishments.push({ ...action.newlyAddedSportsAccomplishment, uploadedImage: action.uploadedImage })
        }

        console.log("updatedSportsAccomplishments", updatedSportsAccomplishments)

        let totalCount=0;
        let finaldata=[];
        let setCardItemDataShow=false;

        totalCount = updatedSportsAccomplishments.length

        let getCardItemData = updatedSportsAccomplishments.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCount > 3) {
          setCardItemDataShow = true
        }


        if(getCardItemData.length > 0) {
          for (let i = 0; i < getCardItemData.length; i++) {
            const data = getCardItemData[i].newdata;
            let img =   getCardItemData[i].uploadedImage;
            if(img !="" && img!=undefined)
            {
                getCardItemData[i]['profile_image']=img;
            }
            let datecheck = checkdate(data);
  
            getCardItemData[i]['datecheck'] = datecheck;
  
            //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed
  
            ///handling logic
          }
        }

        let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

        finaldata = getCardItemData2
      
        return{
        ...state,
        opentost:action.opentost,
        tost_msg:action.tost_msg,
        sportaccomplishmentscardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,
        sportaccomplishmentstotalCount: totalCount,
        cardItemDataShow: setCardItemDataShow,   
        sportaccomplishmentscardData: action.getCardData 
        };
      
      case UPDATE_SPORTACCOMPLISHMENT: 
        if(!action.updatedSportsAccomplishmentItem) {
          // sport accomplishment coould not be updated, return back the state
          return {
            ...state
          }
        }

        const matchingSportAccIndex = state.sportaccomplishmentscardItemData.findIndex(sportAccItem => sportAccItem.id === action.updatedSportsAccomplishmentItem.id)

        let matchingSportAccItem = undefined
        if(matchingSportAccIndex !== -1) {
          if(action.uploadedImage) {
            matchingSportAccItem = state.sportaccomplishmentscardItemData[matchingSportAccIndex]
            matchingSportAccItem['profile_image'] = action.uploadedImage
            matchingSportAccItem['newdata'] = action.updatedSportsAccomplishmentItem.newdata
            if(matchingSportAccItem) {
              state.sportaccomplishmentscardItemData[matchingSportAccIndex] = matchingSportAccItem
            }
          } else {
            state.sportaccomplishmentscardItemData[matchingSportAccIndex] = action.updatedSportsAccomplishmentItem
          }
        }

        return {
          ...state
        }

      case DELETE_SPORTACCOMPLISHMENT: 
        if(action.deleteSuccess) {
          const sportsAccomplishmentAfterDelete = action.sportsAccomplishmentcardItemData

          let totalCountAfterDelete
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;

          totalCountAfterDelete = sportsAccomplishmentAfterDelete.length

          let cardItemsData = sportsAccomplishmentAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }


          if(cardItemsData.length > 0){
            for(let i=0;i< cardItemsData.length;i++) {
              const data = cardItemsData[i].newdata;
              let img = cardItemsData[i].uploadedImage
              {
                cardItemsData[i]['profile_image']=img;
              }
              let datecheck = checkdate(data);
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }

          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

          finaldataAfterDelete = cardItemsData2

          return {
            ...state,
            sportaccomplishmentscardItemData: finaldataAfterDelete,
            sportaccomplishmentstotalCount: totalCountAfterDelete,
            cardItemDataShow: setCardItemDataShowAfterDelete
          }
        } else {
          //delete was not successfull, just return back the state
          return {
            ...state
          }
        }
        
      case TOST_MESSAGE:
        return{
          ...state,
          openTost:action.openTost,
          Tost_msg:action.Tost_msg,
          Msg_type:action.Msg_type,
        };
    default: return state;
  }
};